import React from 'react';
import NavigationTitle, { LayoutType } from 'ui/NavigationTitle/NavigationTitle';
import Button, { Themes } from 'ui/Button/Button';
import TransactionCard, { ITransactionField } from 'ui/structure/TransactionCard';
import ModalWindow from '../ModalWindow/ModalWindow';
import styles from './TransactionDetails.module.css';
import fail from 'assets/icons/fail.png';
import check from 'assets/icons/check.png';

interface IProps {
  isApproveReject?: boolean;
  data: ITransactionField[];
  open: boolean;
  onClose: () => void;
  onClickApprove?: () => void;
  onClickReject?: () => void;
}

const TransactionDetails = ({ data, open, onClose, onClickApprove, onClickReject, isApproveReject }: IProps) => {
  const handleOnClose = () => {
    onClose();
  };
  const content = (
    <div>
      {isApproveReject ? (
        <div className={styles.btnWrapper}>
          <Button theme={Themes.primary} onClick={onClickApprove}>
            <div className={styles.btnIconWrapper}>
              <img src={check} alt="approve_icon" />
            </div>
            Approve
          </Button>
          <Button theme={Themes.primary} onClick={onClickReject}>
            <div className={styles.btnIconWrapper}>
              <img src={fail} alt="reject_icon" />
            </div>
            Reject
          </Button>
        </div>
      ) : (
        <Button type="button" className={styles.btnSubmit} theme={Themes.primary} fullWidth onClick={onClose}>
          Close
        </Button>
      )}
    </div>
  );

  return (
    <ModalWindow open={open} onClose={handleOnClose} fullScreen>
      <NavigationTitle to="#/" onClick={onClose} layoutType={LayoutType.dashboard} className={styles.navTitle}>
        Transaction Details
      </NavigationTitle>
      {data && <TransactionCard fields={data} className={styles.card} />}
      {content}
    </ModalWindow>
  );
};

export default TransactionDetails;
